(function(a,b){var c=function(a,b,c){var d;return function e(){function g(){if(!c)a.apply(e,f);d=null}var e=this,f=arguments;if(d)clearTimeout(d);else if(c)a.apply(e,f);d=setTimeout(g,b||20)}};jQuery.fn[b]=function(a){return a?this.bind("resize",c(a)):this.trigger(b)}})(jQuery,"smartresize")

var ReactTheme = {};
var $masonry = $('.masonry');
var navigationTopOffset;
var navigationHeight;

jQuery(window).load(function(){
  
  $masonry.show();
  
  
  navigationTopOffset = $('#nav').offset().top;
  navigationHeight = $('nav.main').height();
  
  
});

jQuery(document).ready(function($){
  
  $('a.fancy').fancybox( {
    padding : 0,
    helpers : {      
      overlay : {
       css : {
         'background' : 'rgba(255, 255, 255, 0.95)'
       }
      }
    }
  } );
  
  
  /* Initialize zoom on main product image */
  var mainProductImage = $('.image.featured img');
  if (mainProductImage.size()) {
    var zoomedSrc = mainProductImage.attr('src').replace('_1024x1024', '');
    mainProductImage
    .wrap('<span style="display:inline-block;max-width:100%"></span>')
    .css('display', 'block')
    .parent()
    .zoom( { url: zoomedSrc } );
  }
  
  
  
  $masonry.imagesLoaded(function(){
    $masonry.masonry({
      itemSelector : '.masonry-item'
    });
  });
  
  $(window).smartresize(function(){
    $masonry.masonry('reload');
  });
  

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });
   
  ReactTheme.switchImage = function(newSizedImageSrc, newImage, mainImageDomEl) {
    var largestImage = newSizedImageSrc.replace('_1024x1024', '');
    $(mainImageDomEl).parents('a').attr('href', largestImage);
    $('#zoom-image').attr('href', largestImage);
    $(mainImageDomEl).attr('src', newSizedImageSrc);
    
    jQuery(mainImageDomEl).parent().trigger('zoom.destroy').zoom( { url: largestImage } );
    
  };
           
  $('#product .thumbs a').click(function(e){
    e.preventDefault();
    var newSizedImageSrc = $(this).attr('href');
    var mainImageDomEl = $('.image.featured img')[0];
    ReactTheme.switchImage(newSizedImageSrc, null, mainImageDomEl);
    return false;
  });
  
  
  
  
  navigationTopOffset = $('#nav').offset().top;
  $(window).scroll(function(){
    navigationHeight = $('nav.main').height();
    navigationHeight += 20;
    if($(window).scrollTop() > navigationTopOffset){
      $('body').addClass('fixed-navigation');
      $('body').css('padding-top', navigationHeight + 'px');
    } else {
      $('body').removeClass('fixed-navigation');
      $('body').css('padding-top', '0');
    }
  });
  
  
  // remove ugly outline on input button click
  $('input[type="submit"], input.btn, button').click(function(){ 
    $(this).blur();
  })
  
  $('li.dropdown').hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });
  
});